import { Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { Clinician } from '../../clinician-dashboard/clinicianDashboardSlice';
import { closeDashboardModal, DASHBOARD_MODAL } from './modalDashboardSlice';

export const RedirectModal = ({ clinicians }: { clinicians?: Clinician[] }) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const navigate = useNavigate();
  const location = useLocation();
  const isClinicianDashboard = location.pathname.includes('clinician-dashboard');
  const modal = useAppSelector((state) => state.modalDashboardSlice.modal);
  const clinicianId = useAppSelector((state) => state.clinicianDashboardSlice.clinicianDashboardData.clinician_id);
  const programDashboardData = useAppSelector((state) => state.programDashboardSlice.programDashboardData);
  const sites = useAppSelector((state) => state.adminSitesSlice.adminSites);

  return (
    <Modal
      className="dashboardModal"
      title="Confirmation"
      open={modal === DASHBOARD_MODAL.NO_ACTIVITY}
      onCancel={() => {
        capturePostHogCustomEvent('RedirectModal close modal');
        dispatch(closeDashboardModal());
      }}
      centered
      onOk={() => {
        if (isClinicianDashboard) {
          const clinician = clinicians?.find((c) => c.id === clinicianId);
          if (clinician) {
            navigate(`/page/inactive-clients?clinician=${clinician.full_name}`);
          }
        } else {
          const site = sites.find((s) => s.id === programDashboardData.previousParams.site_id)?.name;
          navigate('/page/inactive-clients' + (site ? `?site=${site}` : ''));
        }
        capturePostHogCustomEvent('RedirectModal redirect to inactive-clients page');
        dispatch(closeDashboardModal());
      }}
      okText="OK"
      cancelText="Cancel"
      cancelButtonProps={{ type: 'default' }}
      mask={{ blur: false, closable: false }}
      closable={false}
    >
      <p>
        You will be navigated to a new page to see these details. <br />
        You can use the back button in your browser to return to the Program dashboard.
      </p>
    </Modal>
  );
};
